"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDevices_en_us = void 0;
function backofficeDevices_en_us() {
    return {
        "backoffice.devices.title": "Devices",
        "backoffice.devices.subtitle": "Couple your devices and control the displayed content.",
        "backoffice.devices.add": "Add device",
        "backoffice.devices.name": "Name",
        "backoffice.devices.paired": "Paired",
        "backoffice.devices.currentcontent": "Current Content",
        "backoffice.devices.lastcontact": "Last Contact",
        "backoffice.devices.nocontact": "Never",
        "backoffice.devices.configure.title": "Configure Device \"${deviceName}\"",
        "backoffice.devices.configure.webview": "WebView Link",
        "backoffice.devices.configure.fullscreen": "Full screen",
        "backoffice.devices.configure.selectdata.title": "Select content type",
        "backoffice.devices.configure.selectdata.application.title": "Application",
        "backoffice.devices.configure.selectdata.application.description": "Send an application to your device",
        "backoffice.devices.configure.selectdata.application.secondtitle": "Select the application you want to send to your device",
        "backoffice.devices.configure.selectdata.checkin.title": "Check-In App",
        "backoffice.devices.configure.selectdata.checkin.description": "Send a Check-In App to your device",
        "backoffice.devices.configure.selectdata.checkin.secondtitle": "Select the Check-In App you want to send to your device",
        "backoffice.devices.configure.selectdata.checkin.warning": "Further updates will not overwrite this Check-In App on your device again, since customers could actually be using it. If you want to apply further changes to your device, please save the configuration and hit the reload button in the Applications App on your device.",
        "backoffice.devices.configure.selectdata.checkin.printer": "Printer Configuration",
        "backoffice.devices.configure.selectdata.website.title": "Website",
        "backoffice.devices.configure.selectdata.website.description": "Send any website to your device",
        "backoffice.devices.configure.selectdata.website.secondtitle": "Please provide the URL of the website you want to send to your device",
        "backoffice.devices.configure.sendbtn": "Send to device",
        "backoffice.devices.code.title": "Code",
        "backoffice.devices.code.description": "Use the code displayed on your device",
        "backoffice.devices.empty.title": "No devices found...",
        "backoffice.devices.empty.meanwhile": "You can add and pair devices via Firebase Cloud Messaging here. Go ahead and try it!",
        "backoffice.devices.empty.adddevice": "Add your first device",
        "backoffice.devices.editor.title": "Connect Device"
    };
}
exports.backofficeDevices_en_us = backofficeDevices_en_us;
